/**
 * The TutoriallistController class is designed to manage the navigation of a pageable sequence of items,
 * like the video list.
 *
 * It displays all its elements using the same button classes in a vertical layout. It manages
 * proper tabbing and arrow key navigation.
 */
class TutoriallistController {
  /*-----------------------------------*\
   * Constructor
  \*-----------------------------------*/
  constructor($timeout, $state, $rootScope, analyticsService) {

    this.name = 'tutoriallist';
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.analyticsService = analyticsService;

    this.listId = 'navigation';
    this.selectedIndex = this.$rootScope.selectedIndex || 0;
    this.maxItems = 8;
    this.startIndex = 0;
    this.page_num = 1;
    this.ix = 0;
    this.menuitemsLoader= true;

    this.$state = $state;
    this.currentState = $state.current.name;

    this.$timeout(() => {
      if (this.currentState === 'home.tutorials') {
        this.fromTutorial = true;
        this.fromFaq = false;
        this.tutorialData();
        this.menuitemsLoader = false;

      } else {
        this.fromFaq = true;
        this.fromTutorial = false;
        this.faqData();
        this.menuitemsLoader = false;
      }
      this.total_page_num = Math.floor(this.menuitems.length / this.maxItems) + 1;
      this.focusSelectedIndex();
    }, 500);

  }

  set items(value) {
    this.menuitems = value;
  }

  get items() {
    return this.menuitems;
  }

  get displayItems() {
    return (this.menuitems && this.menuitems.length) ? this.menuitems.slice(this.startIndex, this.startIndex + this.maxItems) : [];
  }

  tutorialData () {
    this.displayImage = this.menuitems[this.selectedIndex].link;
  }

  faqData () {
    this.loader = true;
    this.$timeout(() => {
      if(this.menuitems[this.selectedIndex].layout === 'summary_without_image') {
        this.menuitems[this.selectedIndex].summary.length > 300 ? document.getElementsByClassName('faq-summary')[0].innerHTML = this.menuitems[this.selectedIndex].summary.substring(0,300).concat('...') :
          document.getElementsByClassName('faq-summary')[0].innerHTML = this.menuitems[this.selectedIndex].summary;
      } else if (this.menuitems[this.selectedIndex].layout === 'summary_with_image') {
        this.menuitems[this.selectedIndex].summary_with_image.length > 135 ? document.getElementsByClassName('faq-summary')[0].innerHTML = this.menuitems[this.selectedIndex].summary_with_image.substring(0,135).concat('...') :
          document.getElementsByClassName('faq-summary')[0].innerHTML = this.menuitems[this.selectedIndex].summary_with_image;
      }
      this.displayFaqImage = this.menuitems[this.selectedIndex].summary_image;
      this.loader = false;
    }, 500);

    this.displayTitle = this.menuitems[this.selectedIndex].title;
    this.displaySubTitle = this.menuitems[this.selectedIndex].sub_title;
    this.displayLayout = this.menuitems[this.selectedIndex].layout;
  }

  isUp(event) {
    return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
  }

  isDown(event) {
    return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
  }

  isRight(event) {
    return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
  }

  isLeft(event) {
    return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
  }

  keyDownHandler(event) {
    var cancel = event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.ignoreNextUp = true;
    }
    if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
      window.removeEventListener('keydown', this.keydown);
      this.currentState === 'home.faq' ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
      this.$rootScope.selectedIndex = 0;
      this.$state.go('home.landingpage');
    } else if((event.code === 'Enter' || event.keyCode === 13) && this.currentState === 'home.faq' ) {
      //omniture Faq item click
      console.log('omniture Faq item click' +this.displayTitle);

      this.analyticsService.sendReport('quick tips', 'quick tips', null, null, null, this.displayTitle, this.displayTitle,
        this.$rootScope.analytics.omniturePath +'/faqtemplate', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, 
        this.$rootScope.analytics.omniturePath +'/faq');

      this.$rootScope.selectedIndex = this.selectedIndex;
      this.$state.go('home.faqtemplate');
    } else if((event.code === 'Enter' || event.keyCode === 13) && this.currentState === 'home.tutorials' ){
      //omniture tutorial item click
      console.log('omniture Tutorial item click : ' +this.menuitems[this.selectedIndex].title );
      this.analyticsService.sendReport('tutorials', 'tutorials', null, null, this.menuitems[this.selectedIndex].title, null, 
        this.menuitems[this.selectedIndex].title, this.$rootScope.analytics.omniturePath +'/videoplayer', this.$rootScope.omnitureBillingStatus, 
        this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/tutorials');

      console.log('this.menuitems[this.selectedIndex].url is ' + this.menuitems[this.selectedIndex].url);
      this.$rootScope.selectedIndex = this.selectedIndex;
      this.$rootScope.title = this.menuitems[this.selectedIndex].title;
      this.$state.go('videoplayer', {

        back: true,

        url: this.menuitems[this.selectedIndex].url

      });
    } else if ((event.code === 'Tab' && !event.shiftKey) || this.isDown(event)) {
      // Down arrow or tab key
      if((this.startIndex + this.selectedIndex - this.ix )% (this.maxItems - 1)=== 0 && this.selectedIndex !== 0 ||
        this.selectedIndex + 1 === this.menuitems.length) {
        //if it is last or first item
        this.pageDown();
        cancel(event);
      } else if (this.selectedIndex + 1 < this.menuitems.length) {
        //if it is any item
        this.selectedIndex++;
        this.fromTutorial ? this.tutorialData() : this.faqData();
        this.focusSelectedIndex();
        cancel(event);
      }
    } else if ((event.code === 'Tab' && event.shiftKey) || this.isUp(event)) {
      // Up arrow or shift tab
      if((this.selectedIndex - 1) % (this.maxItems - 1)=== 0 && this.selectedIndex !== 1) {
        cancel(event);
      } else if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.focusSelectedIndex();
        this.fromTutorial ? this.tutorialData() : this.faqData();
        cancel(event);
      } else if(this.selectedIndex === 0) {
        this.pageUp();
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }

  focusSelectedIndex() {
    var elId = this.listId + '_btn' + this.selectedIndex;
    var el = document.getElementById(elId);

    if (el) {
      el.focus();
    } else {
      this.$timeout(this.focusSelectedIndex.bind(this));
    }
  }

  pageDown() {
    if(this.page_num === this.total_page_num) {
      document.getElementById('prev-btn').focus();
    } else {
      document.getElementById('next-btn').focus();
    }
  }

  pageUp() {
    if(this.page_num === 1){
      document.getElementById('next-btn').focus();
    } else {
      document.getElementById('prev-btn').focus();
    }
  }

  nextKeyHandler(event) {
    if(this.isLeft(event) && this.page_num != this.total_page_num && this.page_num != 1) {
      document.getElementById('prev-btn').focus();
    }
    if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
      window.removeEventListener('keydown', this.keydown);
      this.$rootScope.selectedIndex = 0;
      this.fromFaq ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
      this.$rootScope.selectedIndex = 0;
      this.$state.go('home.landingpage');
    }
    if (event.code === 'Enter') {
      this.ix++;
      this.startIndex += this.maxItems;
      this.selectedIndex += this.ix;
      this.page_num = this.page_num + 1;
      this.focusSelectedIndex();
    }
  }

  prevKeyHandler(event) {
    if(this.isRight(event) && this.page_num != this.total_page_num && this.page_num != 1) {
      document.getElementById('next-btn').focus();
    }
    if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
      window.removeEventListener('keydown', this.keydown);
      this.$rootScope.selectedIndex = 0;
      this.fromFaq ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
      this.$rootScope.selectedIndex = 0;
      this.$state.go('home.landingpage');
    }
    if (event.code === 'Enter') {
      this.ix--;
      this.startIndex -= this.maxItems;
      this.selectedIndex -= this.maxItems;
      if ((this.selectedIndex % this.startIndex) !== 0) {
        this.temp = (this.selectedIndex % this.maxItems);
        this.selectedIndex -= this.temp;
      }
      this.page_num = this.page_num - 1;
      this.focusSelectedIndex();
    }
  }
}

TutoriallistController.$inject = [
  '$timeout',
  '$state',
  '$rootScope',
  'analyticsService'
];

export default TutoriallistController;



// WEBPACK FOOTER //
// ./client/app/components/tutoriallist/tutoriallist.controller.js